import React from 'react'
import { StyledDateInput, Props } from './styled'

export const DateInput: React.FC<Props> = (props: Props) => {
  return <StyledDateInput {...props} />
}
